import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "radio-item__label" }
const _hoisted_2 = ["name", "value", "checked", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "radio-item__icon" }, null, -1)
const _hoisted_4 = { class: "radio-item__txt" }
const _hoisted_5 = {
  key: 0,
  class: "radio-item__sub"
}

import {
  useAttrs,
  withDefaults,
  defineOptions,
} from "vue";
import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  label?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'radio-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    label: {},
    name: {},
    value: {},
    checked: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }) {

const props = __props;




const attrs = useAttrs();


const inputEvent = (e: Event) => {
  emit("update", (e.target as HTMLInputElement).value);
};

const statusChecked = (): boolean => {
  if (props.checked && true) {
    return true;
  }
  if (attrs.modelValue) {
    return attrs.modelValue === props.value;
  }
  return false;
};

const componentClass = () =>
  mapModifires(
    "radio-item",
    mergeModifires(props.modifires, props.disabled && "disabled")
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", _mergeProps({ onChange: inputEvent }, _ctx.$attrs, {
        class: "radio-item__input",
        name: _ctx.name,
        type: "radio",
        value: _ctx.value,
        checked: statusChecked(),
        disabled: _ctx.disabled
      }), null, 16, _hoisted_2),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    (_ctx.$slots.sub)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "sub")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})